import { LOADING_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT_FAILED } from '../types';
import { createFetcher } from '../utils';
import { identificationType } from '../../constants';

export default {
  urlFormatter: {
    [identificationType.pii]: ({ pii, token }) => `/enhancements/article/document-id/${pii}/context/authors?token=${token}`,
    [identificationType.doi]: ({ doi, token }) => `/enhancements/article/doi/${doi}/context/authors?token=${token}`,
  },
  fetch: createFetcher(
    LOADING_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT, RECEIVED_AUTHOR_CONTEXT_FAILED,
  ),
};
